var map = {
	"./arrow-right-long.svg": 28922,
	"./audio-speaker.svg": 89923,
	"./audio-wave.svg": 40219,
	"./bell.svg": 96100,
	"./broadcast-custom.svg": 58588,
	"./check.svg": 91945,
	"./chevron-down.svg": 63373,
	"./clipbin.svg": 67220,
	"./close.svg": 11653,
	"./delete.svg": 10522,
	"./download.svg": 55487,
	"./edit.svg": 67767,
	"./file.svg": 27213,
	"./filter.svg": 57225,
	"./folder.svg": 34291,
	"./fullscreen.svg": 44324,
	"./image.svg": 70394,
	"./info.svg": 92027,
	"./input.svg": 43021,
	"./list.svg": 46111,
	"./loading.svg": 19337,
	"./logout.svg": 67661,
	"./loop.svg": 94149,
	"./more.svg": 55180,
	"./opening-times.svg": 4336,
	"./output.svg": 36816,
	"./peakmeter.svg": 78213,
	"./permissions.svg": 50829,
	"./play.svg": 37277,
	"./plus.svg": 14195,
	"./question.svg": 88875,
	"./record.svg": 76136,
	"./refresh.svg": 26472,
	"./reload.svg": 86816,
	"./right-arrow.svg": 81375,
	"./route.svg": 3046,
	"./stop.svg": 3395,
	"./tasks.svg": 67851,
	"./time.svg": 75120,
	"./transcript.svg": 14613,
	"./upload.svg": 91744,
	"./url.svg": 35398,
	"./user-add.svg": 8680,
	"./user.svg": 79234,
	"./warning-2.svg": 9632,
	"./warning.svg": 2537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60568;